/** The look the fingering testing aids share: small and dark, at home in the
 *  lesson's toolbar. */
export const aidPanelSx = {
  borderRadius: '8px',
  border: '1px solid rgba(121, 216, 255, 0.3)',
  backgroundColor: 'rgba(5, 11, 19, 0.96)',
  color: '#EAF2FF',
  padding: '4px 8px',
  fontFamily: 'Lato, sans-serif',
  fontSize: '11px',
  lineHeight: 1.3,
} as const;

export const aidButtonSx = {
  ...aidPanelSx,
  cursor: 'pointer',
  fontWeight: 700,
  whiteSpace: 'nowrap',
  // A comfortable target for a thumb that still fits the phone's toolbar.
  minHeight: '30px',
  padding: '6px 10px',
  touchAction: 'manipulation',
} as const;
